
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLocationR as ObiLocationRElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-location-r.js';
 
 
 

 
 export const ObiLocationR = createComponent({
   react: React,
   tagName: 'obi-location-r',
   elementClass: ObiLocationRElement,
   events: {
     
   }
  });
 
 